import { Helmet } from "react-helmet-async";

const SEO = ({ title, description, path = "/", type = "website", image }) => {
  const siteName = "Global Metafora APP";
  const baseUrl = "https://globalmetafora.com";
  const fullTitle = title ? `${title} | ${siteName}` : `${siteName} | Sistema Operativo Empresarial Integral`;
  const desc = description || "Sistema operativo empresarial integral que transforma la gestión de tu negocio. ERP, CRM, facturación, inventarios y más.";
  const url = `${baseUrl}${path}`;
  const img = image || `${baseUrl}/og-image.png`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:image" content={img} />
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:title" content={fullTitle} />
      <meta property="twitter:description" content={desc} />
      <meta property="twitter:image" content={img} />
    </Helmet>
  );
};

export default SEO;
